import { QueryClient } from './types';

export function createClient(opts: QueryClient): QueryClient {
  return opts;
}

export { executeQuery } from './query';

export * as simpleCache from './cache';

export * from './types';
